import React from 'react';
import { Stack } from '@mui/material';
import Flex from 'legacyfrontend/components/Flex';
import { formatDate } from 'legacyfrontend/utils/dateUtils';
import DeferredSingleFlightInfoRow from './DeferredSingleFlightInfoRow';

const FlightSingleCard = ({ flightData }) => {
  if (!flightData) return <></>;

  const { journeys } = flightData;

  return (
    <Stack className='flight-card' sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
      <Flex style={{ flexDirection: 'column', flex: 1 }}>
        {/* Vuelo de ida */}
        {journeys.outbound && (
          <Flex style={{ flexDirection: 'column', flex: 1 }}>
            <Flex className='flight_kind_header'>
              <h3 className='flight_kind_header_title'>Vuelo ida</h3>
              <p className='flight_kind_header_date'>
                {formatDate(journeys.outbound.departure_date)}
              </p>
            </Flex>

            <DeferredSingleFlightInfoRow flight={journeys.outbound} kind='ida' />
          </Flex>
        )}

        {/* Vuelo de vuelta */}
        {journeys.return && (
          <Flex style={{ flexDirection: 'column', flex: 1 }}>
            <Flex className='flight_kind_header'>
              <h3 className='flight_kind_header_title'>Vuelo Vuelta</h3>
              <p className='flight_kind_header_date'>
                {formatDate(journeys.return.departure_date)}
              </p>
            </Flex>

            <DeferredSingleFlightInfoRow flight={journeys.return} kind='vuelta' />
          </Flex>
        )}
      </Flex>
    </Stack>
  );
};

export default FlightSingleCard;
